import * as Yup from "yup";

/**
 * Obrazac cjenovne sheme, shema po koraku čarobnjaka.
 *
 * Brana da se `nabava.*` ne smije pregaziti namjerno NIJE ovdje — ona stoji u modelu na
 * backendu, jer se sučelje da zaobići. Ovdje su samo provjere koje štede odlazak na server.
 */

export const SCHEME_BASICS_STEP_SCHEMA = Yup.object().shape({
  name: Yup.string().nullable().required("Naziv grupe je obavezan"),
});

export const SCHEME_ITEMS_STEP_SCHEMA = Yup.object().shape({
  items: Yup.array().of(
    Yup.object().shape({
      keyCode: Yup.string().nullable().required("Ključ je obavezan"),
      value: Yup.number().nullable().required("Vrijednost je obavezna"),
    })
  ),
});
